module.exports = __webpack_public_path__ + "c09f9cd4ffa926acf8ba0ea589d28752.png";